import { createAppSlice } from '../createAppSlice'

export type TicketValidationScope = 'spot' | 'reservation'

interface InitialState {
  submitted: boolean
  validationScope: TicketValidationScope | null
}

const initialState: InitialState = {
  submitted: false,
  validationScope: null,
}

export const ticketSlice = createAppSlice({
  initialState,
  name: 'tickets',
  reducers: (create) => ({
    resetValidation: create.reducer((state) => {
      state.submitted = false
      state.validationScope = null
    }),
    setSubmitted: create.reducer<boolean>((state, action) => {
      state.submitted = action.payload
      if (!action.payload) {
        state.validationScope = null
      }
    }),
    triggerValidation: create.reducer<TicketValidationScope>(
      (state, action) => {
        state.submitted = true
        state.validationScope = action.payload
      }
    ),
  }),
  selectors: {
    submitted: (state) => state.submitted,
    validationScope: (state) => state.validationScope,
  },
})
